import api from 'core/api';

export const getBookings = date => {
	return api.get('/bookings', {
		params: {
			date,
		}
	}).then(res => res.data);
};

export const getMyBookings = uuid => {
	return api.get('/my/bookings', {
		params: {
			device: uuid,
		}
	}).then(res => res.data);
};

export const cancelMyBooking = (booking_id, uuid) => {
	return api.delete('/booking', {
		params: {
			id: booking_id,
			device: uuid,
		}
	}).then(res => res.data);
};

export const getTables = () => {
	return api.get('/tables')
		.then(res => res.data);
};

export const getSettings = () => {
	return api.get('/settings')
		.then(res => res.data);
};

export const sendForm = data => {
	return api.post('/booking', data)
		.then(res => res.data);
};

export const sendReviewForm = data => {
	return api.post('/review', data)
		.then(res => res.data);
};

export const sendCardFindForm = data => {
	return api.post('/card/find', data)
		.then(res => res.data);
};

export const sendCardCreateForm = data => {
	return api.post('/card/create', data)
		.then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/dataProvider/dataContext.js